import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Loading, Report } from "notiflix";
import { Mail } from "lucide-react";
import HelmetMetaData from "@/components/HelmetMetaData";
import { GetRequest, PostRequest } from "@/lib/http";
import { useSelector } from "react-redux";

const Maintenance = () => {
  const isMobile = useMediaQuery({ maxWidth: "390px" });
  const [maintenance, setMaintenanceMessage] = useState(
    "We have almost done all the technical improvements and will be back very soon. Thank you for your patience!",
  );
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);

  async function getData() {
    const { data, err } = await GetRequest({
      url: "/api/get-key/maintenance_message",
    });
    if (!err) {
      setMaintenanceMessage(data.data || maintenance);
    }
  }

  async function refreshStatus() {
    const { data } = await GetRequest({
      url: "/api/get-key/site_available",
    });
    if (data?.data) {
      navigate("/dashboard");
    }
  }

  useEffect(() => {
    getData();
    refreshStatus();
  }, []);

  useEffect(() => {
    const a = setInterval(refreshStatus, 3500);
    return () => {
      clearInterval(a);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    Loading.pulse("Submitting", {
      svgColor: "#395EAC",
    });

    const { err } = await PostRequest({
      url: "/api/news-letter",
      body: new FormData(e.target),
    });
    if (!err) {
      e.target.reset();
      Report.success(
        "Email Recieved",
        "Your email address has been recieved. we will let you know as soon an update turns up",
        "Okay",
      );
    } else {
      Report.failure("Error", err);
    }
    Loading.remove();
  };
  return (
    <>
      <HelmetMetaData
        title="Maintenance Mode - Under Construction"
        description=""
      />

      <div className="font-geist flex h-[100dvh] flex-col items-center justify-center gap-10 bg-white lg:flex-row lg:gap-0">
        <div className="flex w-full flex-col space-y-4 p-5 leading-[1.2] lg:w-1/2 lg:space-y-10 lg:p-20">
          <div className="flex justify-center lg:justify-start">
            <img
              src="/logo-image-black.svg"
              alt="logo"
              className="w-[150px] opacity-80 lg:w-[180px]"
            />
          </div>

          <div className="space-y-4">
            <h1
              className={cn(
                "text-center text-[40px] leading-[1.1] font-medium text-black/75 md:text-6xl lg:text-start lg:text-5xl",
                {
                  "text-[37px] leading-[1.1]": isMobile,
                },
              )}
            >
              The website is in maintenance mode.
            </h1>

            <div className="flex justify-center lg:justify-start">
              <p className="text-center text-sm text-black/80 md:text-base lg:text-start">
                {maintenance}
              </p>
            </div>
          </div>

          <div className="flex justify-center lg:justify-start">
            <form
              onSubmit={handleSubmit}
              className="flex w-fit items-center rounded-lg border border-gray-300 p-3 md:w-[60%] lg:w-[70%]"
            >
              <input
                type="email"
                required
                name="email"
                placeholder="Enter your email address"
                className="w-fit flex-1 border-none bg-transparent p-3 py-1 text-sm text-gray-800 outline-none"
              />
              <input
                type="hidden"
                name="message"
                value="I put my email from the maintenance page"
              />

              <button className="flex items-center gap-1 text-sm font-medium">
                <Mail size={20} />
                <span>Notify </span>
              </button>
            </form>
          </div>
        </div>
        <div className="flex w-full items-center justify-center lg:h-full lg:w-1/2 lg:bg-gray-200">
          <img
            src="/maintenance-img.webp"
            alt="maintenance-img"
            className="w-[90%] md:w-[60%] lg:w-[70%]"
          />
        </div>
      </div>
    </>
  );
};

export default Maintenance;
